function convertBlobToImage(blob) {
  // console.log("Converting blob to image", blob);
  const url = URL.createObjectURL(blob);
  const img = document.createElement("img");
  img.src = url;
  return img;
}

export { convertBlobToImage };